import React, { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, X, Calendar } from "lucide-react";
import Logo from "@/components/Logo";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/products", label: "Products" },
  { to: "/solutions", label: "Solutions" },
  { to: "/why-us", label: "Why SiliconPay" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="sp-navbar"
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled ? "shadow-[0_8px_24px_-18px_rgba(10,31,92,0.4)]" : ""
      }`}
      style={{ background: "linear-gradient(90deg,#061544 0%,#0a1f5c 100%)" }}
    >
      <div className="sp-container flex items-center justify-between py-3">
        <Link to="/" data-testid="nav-logo-link">
          <Logo variant="dark" />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) => `sp-nav-link ${isActive ? "active" : ""}`}
              data-testid={`nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Link to="/contact" className="sp-btn-gold" data-testid="nav-cta-consultation">
            <Calendar size={18} /> Schedule a Consultation
          </Link>
        </div>

        <button
          aria-label="Toggle menu"
          className="lg:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden border-t border-white/10 bg-[#0a1f5c]" data-testid="nav-mobile-menu">
          <div className="sp-container py-4 flex flex-col gap-3">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `py-2 text-[0.95rem] ${isActive ? "text-white font-semibold" : "text-white/80"}`
                }
                data-testid={`nav-mobile-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {item.label}
              </NavLink>
            ))}
            <Link to="/contact" className="sp-btn-gold justify-center mt-2" data-testid="nav-mobile-cta">
              <Calendar size={18} /> Schedule a Consultation
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
